var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { OnInit } from '@angular/core';
import { DriveEntryApiService } from '../../drive-entry-api.service';
import { Store } from '@ngxs/store';
import { DriveState } from '../../state/drive-state';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { Translations } from 'common/core/translations/translations.service';
import { ContextMenu } from 'common/core/ui/context-menu/context-menu.service';
import { DriveContextMenuComponent } from '../../context-actions/components/drive-context-menu/drive-context-menu.component';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { OpenFolder } from '../../state/actions/commands';
import { ROOT_FOLDER } from '../../folders/root-folder';
import { DriveFolderPage, ROOT_FOLDER_PAGE, SHARES_PAGE } from '../../state/models/drive-page';
import { Navigate } from '@ngxs/router-plugin';
var EntryBreadcrumbsComponent = /** @class */ (function () {
    function EntryBreadcrumbsComponent(entriesApi, i18n, contextMenu, store) {
        this.entriesApi = entriesApi;
        this.i18n = i18n;
        this.contextMenu = contextMenu;
        this.store = store;
        this.breadcrumb = new BehaviorSubject([]);
    }
    EntryBreadcrumbsComponent.prototype.ngOnInit = function () {
        var _this = this;
        // wait until entries and user folders are loaded
        var sub = combineLatest(this.store.select(DriveState.meta), this.store.select(DriveState.userFoldersLoaded)).subscribe(function (combined) {
            if (combined[0].currentPage && combined[1]) {
                _this.bindToActivePage();
                sub && sub.unsubscribe();
            }
        });
    };
    EntryBreadcrumbsComponent.prototype.openPage = function (page) {
        if (page.folder) {
            this.store.dispatch(new OpenFolder(page.folder));
        }
        else {
            this.store.dispatch(new Navigate(['/drive/shares']));
        }
    };
    EntryBreadcrumbsComponent.prototype.openContextMenu = function (item, origin) {
        var params = { originX: 'start', overlayX: 'start' };
        switch (item.name) {
            case 'trash':
                return this.contextMenu.open(DriveContextMenuComponent, origin, params);
            case 'root':
                return this.contextMenu.open(DriveContextMenuComponent, origin, params);
            case 'folder':
                params = __assign({ data: { entry: this.store.selectSnapshot(DriveState.activeFolder) } }, params);
                return this.contextMenu.open(DriveContextMenuComponent, origin, params);
        }
    };
    EntryBreadcrumbsComponent.prototype.generateBreadCrumb = function (page, folders) {
        var breadcrumbs = [page.name === 'folder' ? this.getFolderRootBreadcrumb(page) : page];
        if (page.folder && page.folder !== ROOT_FOLDER) {
            var folderPath = this.getBreadcrumbForFolder(page.folder, folders);
            breadcrumbs.push.apply(breadcrumbs, folderPath);
        }
        this.breadcrumb.next(breadcrumbs);
    };
    EntryBreadcrumbsComponent.prototype.getBreadcrumbForFolder = function (folder, allFolders) {
        return folder.path.split('/').map(function (id) {
            var pathFolder = folder.id === +id ? folder : allFolders[id];
            return pathFolder && new DriveFolderPage(pathFolder);
        }).filter(function (f) { return !!f; });
    };
    EntryBreadcrumbsComponent.prototype.getFolderRootBreadcrumb = function (page) {
        var userOwnsFolder = this.store.selectSnapshot(DriveState.userOwnsActiveFolder);
        if (!page.folder || userOwnsFolder) {
            return ROOT_FOLDER_PAGE;
        }
        else {
            return SHARES_PAGE;
        }
    };
    EntryBreadcrumbsComponent.prototype.bindToActivePage = function () {
        var _this = this;
        combineLatest(this.store.select(DriveState.activePage), this.store.select(DriveState.flatFolders)).pipe(distinctUntilChanged(), filter(function (combined) {
            // wait until folder data is fully loaded
            return !combined[0].folderHash || combined[0].folder;
        })).subscribe(function (combined) {
            _this.generateBreadCrumb(combined[0], combined[1]);
        });
    };
    return EntryBreadcrumbsComponent;
}());
export { EntryBreadcrumbsComponent };
